import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { TableFiltersProps } from 'modules/types'
import { FC } from 'react'
import { AClearFiltersButton } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { SearchFilter } from 'views/components/SearchFilter/SearchFilter'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { CommonRegionFilter } from 'views/components/TableFilters/RegionsFilters/CommonRegionFilter'

export const elevatorsDefaultFilters = {
  country: '3',
}
export const ElevatorsFilters: FC<TableFiltersProps> = ({
  setListRequestParams,
  updateFilterState,
  listRequestParams,
}) => {
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
    defaultFilters: elevatorsDefaultFilters,
  })

  return (
    <div>
      <FiltersAndSearchWrapper>
        <FiltersWrapper>
          <CommonRegionFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
          {displayClearBtn && (
            <AClearFiltersButton
              onClick={() =>
                setListRequestParams({
                  ...defaultListRequestParams,
                  ...{ filter: { ...elevatorsDefaultFilters } },
                })
              }
            />
          )}
        </FiltersWrapper>
        <SearchFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />
      </FiltersAndSearchWrapper>
    </div>
  )
}
